import { useParams } from "react-router-dom";

import { TeamChatView } from "@/features/team-sessions/components/TeamChatView";

/**
 * Chat de team session (entrada pela sessão). A thread só é criada
 * (type=team) quando o usuário envia a primeira mensagem -- até lá o
 * ``TeamChatView`` opera em modo rascunho. Conversas de time já existentes
 * abrem pelo ``ChatPage`` (que também renderiza o ``TeamChatView``).
 */
export function TeamSessionChatPage() {
  const { sessionId = "" } = useParams<{ sessionId: string }>();
  return <TeamChatView sessionId={sessionId} backTo={`/sessions/${sessionId}`} />;
}
